import request from '@aned/request';

// eslint-disable-next-line max-len
// @docs http://10.10.106.144:8088/swagger-ui.html#/%E4%B8%B4%E6%97%B6%E8%B7%AF%E7%94%B1(%E6%96%B0)%E6%9F%A5%E8%AF%A2%E6%8E%A5%E5%8F%A3

/**
 * 分页查询
 *
 * @param params 分页查询参数
 * @returns 返回请求结果的Promise对象
 */
export async function selectPage(params) {
  return request('/api/adjust/selectPage', {
    method: 'POST',
    body: params,
    reqType: 'json',
    module: 'temporary',
  });
}

/**
 * 调整原因明细获取（配置项）
 *
 * @param params 请求参数
 * @returns 返回请求结果
 */
export async function selectAdjustRemarkBaseList(params) {
  return request('/api/adjust/selectAdjustRemarkBaseList', {
    method: 'POST',
    body: params,
    module: 'temporary',
  });
}

/**
 * 临时路由审批
 *
 * @param params 审计参数
 * @returns 返回一个 Promise 对象，resolve 值为请求结果，reject 值为请求错误
 */
export async function audit(params) {
  return request('/api/adjust/audit', {
    method: 'POST',
    body: params,
    reqType: 'json',
    module: 'temporary',
  });
}
/**
 * 校验临时路由审批
 *
 * @param params 参数
 */
export async function checkAudit(params) {
  return request('/api/adjust/checkAudit', {
    method: 'POST',
    body: params,
    reqType: 'json',
    module: 'temporary',
  });
}

// 获取临调货物情况
export async function selectCollectDetail(params) {
  return request('/api/adjustDetail/selectCollectDetail', {
    method: 'POST',
    body: params,
    reqType: 'json',
    module: 'temporary',
  });
}
// 获取临调货物明细
export async function selectCollectDetailList(params) {
  return request('/api/adjustDetail/selectList', {
    method: 'POST',
    body: params,
    reqType: 'json',
    module: 'temporary',
  });
}

/**
 * 关联流向空爆查询
 *
 * @param params 请求参数
 * @returns Promise<any> 返回Promise对象，解析后得到请求结果
 */
export async function queryWaybillNoCollectByRoute(params) {
  return request('/api/adjust/queryWaybillNoCollectByRoute', {
    method: 'POST',
    body: params,
    reqType: 'json',
    module: 'temporary',
  });
}

/**
 * 查询剩余仓位(T)
 *
 * @param params 查询参数
 * @returns 返回请求结果
 */
export async function queryGapVolume2(params) {
  return request('/api/route/queryGapVolume2', {
    method: 'POST',
    body: params,
    reqType: 'json',
  });
}
